import React, { Component } from "react";
import { Radio, Space, message, Spin } from "antd";
import Bridge from "../../utils/Bridge";
import dayjs from "dayjs";
import { logEvent } from "../../utils/analytics";

export default class PhysicalCharachteristics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dominant_hand: "",
      height_in_feet: "",
      height_in_inches: "",
      weight: "",
      dominant_hand_other_specification: "",
      loading: false,
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "What is your dominant hand?") {
                this.setState({ dominant_hand: item.value });
              }
              if (item.field == "Specification") {
                this.setState({
                  dominant_hand_other_specification: item.value,
                });
              }
              if (item.field == "Height In Feet") {
                this.setState({ height_in_feet: item.value });
              }
              if (item.field == "Height In Inches") {
                this.setState({ height_in_inches: item.value });
              }
              if (item.field == "Weight") {
                this.setState({ weight: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_birth: date,
    });
  };
  onChangeDominantHand = (event) => {
    this.setState({
      dominant_hand: event.target.value,
      dominant_hand_other_specification: "",
    });
  };
  save = (goToNextStep = true) => {
    if (goToNextStep) {
      if (!this.state.height_in_feet) {
        message.warning("Height (in feet) is required");
        return;
      }
      if (!this.state.height_in_inches) {
        message.warning("Height (in inches) is required");
        return;
      }
      if (this.state.height_in_feet) {
        if (
          this.state.height_in_feet <= 3 ||
          this.state.height_in_feet >= 9 ||
          this.state.height_in_feet == 0
        ) {
          message.warning("Please enter valid value of Height (In Feet)");
          return;
        }
      }
      if (this.state.height_in_inches) {
        if (this.state.height_in_inches >= 13) {
          message.warning("Please enter valid value of Height (In Inch)");
          return;
        }
      }

      if (!this.state.weight) {
        message.warning("Weight (in Lbs) is required");
        return;
      }
      if (this.state.weight) {
        if (this.state.weight <= 88 || this.state.weight >= 500) {
          message.warning("Please enter valid Weight (In Lbs)");
          return;
        }
      }
    }
    const saveForLater = !goToNextStep;

    let missingFields = [];
    if (!this.state.height_in_feet || this.state.height_in_feet <= 3 || this.state.height_in_feet >= 9 || this.state.height_in_feet == 0) missingFields.push("Height In Feet");
    if (!this.state.height_in_inches || this.state.height_in_inches >= 13) missingFields.push("Height In Inches");
    if (!this.state.weight || this.state.weight <= 88 || this.state.weight >= 500) missingFields.push("Weight");

    const isPhysicalCharachteristicsComplete = missingFields.length === 0 ? 1 : 0;

    let questions = [
      ...(saveForLater
        ? [
            {
              parent_field: "Save",
              field: "Save for later date",
              value: dayjs().format("MM/DD/YYYY HH:mm"),
            },
          ]
        : []),
      {
        parent_field: "Physical Characteristics Save Type",
        field: "Physical Characteristics Save Type",
        value: saveForLater ? "Save for Later" : "Save Physical Characteristics",
      },
      {
        parent_field: "Is Physical Characteristics Fields Submitted",
        field: "Is Physical Characteristics Fields Submitted",
        value: isPhysicalCharachteristicsComplete,
      },
      {
        parent_field: "Physical Characteristics Missing Fields",
        field: "Physical Characteristics Missing Fields",
        value: JSON.stringify(missingFields),
      },
      {
        parent_field: "What is your dominant hand?",
        field: "What is your dominant hand?",
        value: this.state.dominant_hand,
      },
      {
        parent_field: "Height In Inches",
        field: "Height In Inches",
        value: this.state.height_in_inches,
      },
      {
        parent_field: "Height In Feet",
        field: "Height In Feet",
        value: this.state.height_in_feet,
      },
      {
        parent_field: "Weight",
        field: "Weight",
        value: this.state.weight,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "4",
      action_type: this.props.is_update == true ? "update" : "insert",
      ...(saveForLater && { save_for_later: true }),
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          logEvent("demographics_saved", { section: "physical_characteristics" });
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                // if (goToNextStep) {
                  this.props.set_active_step(6);
                // }
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <div>
        <div className="header">
          <h3>PHYSICAL CHARACTERISTICS</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="input-heading">
                What is your dominant hand?
              </label>
              <br />
              <Radio.Group
                onChange={this.onChangeDominantHand}
                value={this.state.dominant_hand}
                direction="vertical"
              >
                <Space direction="vertical">
                  <Radio value={"Right"}>Right</Radio>
                  <Radio value={"Left"}>Left</Radio>
                  <Radio value={"Ambidextrous"}>Ambidextrous</Radio>
                </Space>
              </Radio.Group>
            </div>
            <div className="form-group">
              <label className="mb-2">
                Height <span className="text-danger">*</span>
              </label>
              <br />
              <div className="row">
                <div className="col-lg-6">
                  <input
                    type="number"
                    placeholder="Feet"
                    name="height_in_feet"
                    value={this.state.height_in_feet}
                    onChange={(e) =>
                      this.setState({ height_in_feet: e.target.value })
                    }
                    min={4}
                  />
                </div>
                <div className="col-lg-6">
                  <input
                    type="number"
                    name="height_in_inches"
                    placeholder="Inches"
                    value={this.state.height_in_inches}
                    onChange={(e) =>
                      this.setState({ height_in_inches: e.target.value })
                    }
                    min={0}
                  />
                </div>
              </div>
            </div>
            <div className="form-group">
              <label className="mb-2">
                Weight <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="number"
                name="weight"
                placeholder="Weight (lbs)"
                value={this.state.weight}
                onChange={(e) => this.setState({ weight: e.target.value })}
                max={500}
              />
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button"
                  style={{
                    padding: "9px 15px 10px 20px",
                    width: "164px",
                    whiteSpace: "nowrap",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onClick={() => this.save(false)}
                >
                  Save for Later
                  <box-icon
                    name="save"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                  }}
                  onClick={() => this.props.set_active_step(4)}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                    width: "164px",
                    whiteSpace: "nowrap",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onClick={() => this.save(false)}
                >
                  Save for Later
                  <box-icon
                    name="save"
                    color="#fff"
                    style={{ position: "relative", top: 0 }}
                  ></box-icon>
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save(true)}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
